import type { IconProps } from '../types/IconProps.ts';
export const BriefcaseConveyorBelt: IconProps = {
    name: 'BriefcaseConveyorBelt',
    children: [
        `<path d="M18.4 6H5.6C4.72 6 4 6.58 4 7.29v6.42c0 .71.72 1.29 1.6 1.29h12.8c.88 0 1.6-.58 1.6-1.29V7.3c0-.72-.72-1.3-1.6-1.3" />`,
        `<path d="M8 15V3.44C8 2.64 8.9 2 10 2h4c1.1 0 2 .65 2 1.44V15M4 19h16M6 19v2M10 19v2M14 19v2M18 19v2" />`,
    ]
};